import Utils from '../../../../../utils/immersive_utils';

export function downloadTableAsCsv(
  filename: string,
  columns: { field: string; headerName: string }[],
  rowData: Record<string, unknown>[],
) {
  const headers = columns.map((c) => c.headerName);
  const data = rowData.map((row) => columns.map((c) => String(row[c.field] ?? '')));
  Utils.downloadToCsv(filename, data, headers);
}
